/**
 * Turns a phone number as typed — "(512) 555-0134", "512-555-0134", spaces,
 * anything — into the `+1XXXXXXXXXX` form every auth and verification endpoint
 * expects. Sign-in only accepts US/CA numbers, so the country code is fixed.
 */
export const normalizeUsPhoneNumber = (raw: string): string => {
  const digits = raw.replaceAll(/[^\d]/g, "");
  return digits.length === 11 && digits.startsWith("1") ? `+${digits}` : `+1${digits}`;
};
